<template>
  <div class='say'>
    <div class="sayTop">
      <img src="../../assets/img/pcImg/say.png" alt="">
      <div class="div">{{say.saying}}</div>
    </div>
    <div class="sayMid">
       <div>{{say.name}}</div>
    </div>
    <div class="sayBottom">
      <span  @click='switchSaying'>下一句至理名言</span>
    </div>
  </div>
</template>

<script>
  export default {
    name:'say',
    data () {
      return {
        say: {saying: '[戏剧和诗歌]世界是个舞台，所有的男女都只是演员而已。',
              name: '莎士比亚'},
        str: '这是我们的使命，我们将携手共进。[法典]不是智慧而是权力制定了法律。——托马斯 霍布斯[法典]人在最好的状态下是最高贵的动物；脱离了法典和正义他就是最坏的那个。——亚里士多德[工艺]没有了工艺，灵感就只是风中摇曳的芦苇。——约翰内斯 勃拉姆斯[工艺]没有想象力的工艺只是技巧，它也带给我们很多“好”东西，比如手工编织的野餐篮子。——汤姆 斯托帕德[外贸]每个国家都是靠交易生存下来的。——亚当 斯密[外贸]我想这就是贸易好的地方，它把整个世界搅在一起了。——伊莎贝尔 霍温[军事传统]只有“勇敢”知道，你什么时候在害怕。——克伦奈 大卫 哈克伍茨[军事传统]不是我低估军事知识的价值，但是如果一个人靠奴役统治去打仗，他肯定会失败。——尤利西斯 格兰特{南北战争北军将领}[徭役]一个强大的经济体始于一群强大的、受到良好教育的工人。——比尔 欧文斯[徭役]让工人们高兴并且热衷于所做的事情，和维持盈利同样重要。——韦恩 道兹[早期帝国]回顾历史，看那些帝国在变化中崛起和衰落，你会预见到未来。——马尔库斯 奥列里乌斯[早期帝国]是像空调这样的奢侈品导致了古罗马的灭亡。因为开空调就得关窗户，他们就听不见蛮族们过来了。——加里森 凯勒[神秘主义]神秘主义是一个错误：它试图用巧合的和个体的符号来解释宇宙。——拉尔夫 沃尔多 爱默生[神秘主义]我受过军事神秘主义的训练，我非常确定一些我根本不知道的事情。——罗伯 贝尔 [游戏与娱乐]如果面包是第一需求的话，那么娱乐就是仅次于其后的。——爱德华 贝拉米[游戏与娱乐]那些没时间娱乐的人，他们的时间会花在生病上。——约翰 沃纳梅克[政治哲学]政治学是这样一门艺术，它关心是否可能和是否可得，而不一定是最好的。——奥托 冯 俾斯麦[政治哲学]分而治之，是个不错的箴言；统而率之，则更好。——歌德[戏剧和诗歌]在奶酪这个话题上，诗人们异乎寻常的沉默。——G K 切斯特顿[戏剧和诗歌]世界是个舞台，所有的男女都只是演员而已。——莎士比亚[军事训练]如果说杀戮是天性的话，为什么人们还要训练才能学会呢？——琼 贝兹[军事训练]那些在别人吵架时插嘴的人，一定经常擦鼻血。——约翰 盖伊[战术防御]不可胜者，守也；可胜者，攻也。——孙子[战术防御]良好的防御高于富贵繁荣。——亚当 斯密[记史]我此生经历过很多糟糕的事情，它们中的有一些是真的发生了。——马克吐温{换句话说其他的根本没发生}[记史]历史就是在过去发生的事中，大家一致认同的那部分。——拿破仑[神学]我们不能再强求脱离神学进行宗教思考了，正如我们不能强求脱离数学进行测量和天文研究，或者强求脱离化学去炼铁。——约翰 霍尔[神学]人们痛苦，因为他们把上帝开的玩笑当真了。——阿兰 W 瓦特[海军传统]强大的海军不是战争的挑衅，而是和平的确实保证。——西奥多 罗斯福[海军传统]美国海军既有传统又有未来，我们骄傲地、自信地继承传统，面向未来。——阿利 伯克[封建主义]在民主社会看票数；在封建社会看人数。——摩根斯 加伯格[封建主义]封建社会的发展带动了铠甲的使用，最后每个战士都穿得像犰狳似的。——约翰 博伊尔 欧莱利[公务员]这儿全都是纸和表格，整个公务员系统就像一个用纸、表格和繁琐规定建成的堡垒。——亚历山大 奥斯特洛夫斯基[公务员]纳税人，就是一群给政府打工但不用通过公务员考试的人。——罗纳德 里根[雇佣军]在和平时期，钱被雇佣军搜刮走；在战争时期，钱被敌军搜刮走。——马基雅维利[雇佣军]作为一个雇佣兵，嘿，我们就爱去既有麻烦又有钱的地方。——霍华德 泰勒 [中世纪集镇]你总是听到他们这么说：那些闪闪发亮的都不是金子。——莎士比亚[中世纪集镇]坦诚的人们会告诉你，除非他们骗过了商人，否则都没感觉自己还成了价。——阿纳托尔 法郎士[行会]每个人都该让他的儿子学做一点生意和一项专业技能，这样在这个变化不断的时代里，可以有个求生的本领。——菲尔尼斯 巴纳姆[行会]我们不能绕圈子去逮捕小偷公会，我的意思是说，我们将得在那呆上一整天。——泰瑞 普莱切[君权神授]在此的结论是，在国王权力之上紧邻着神意不言自明的真理，因此如果质疑上帝是亵渎神明的话，质疑国王就是煽动骚乱。——国王詹姆斯一世[君权神授]听着，一个奇怪的女人躺在池塘里撒播利剑不是政府系统的根基，你不能指望使用强权仅凭一个水哒哒的小姐往你身上扔剑。——蒙蒂 派森{池塘指“Lady of the Lake”，典故出自亚瑟王传说} [探索]我们停止探索的那天，就是我们承认我们活在一个停滞世界的那天，失去了好奇，空洞了梦想。——奈儿 德格拉斯 泰森[探索]我们最好不要中止探索。我们探索的终点应该是我们出发的地方，那时我们将第一次真正了解那里。——T S 艾略特[人文主义]人性的四个特征是：好奇心、自由意志、相信高雅、相信人类。——E F 福斯特 [人文主义]你不能对人性失去信念，人性好像一片海洋，即使海洋里的几滴水是脏的，海洋也不会变脏。——甘地[外交部]外交上有两种问题，小问题和大问题。小问题过一阵自己就消失了，大问题你做什么都无济于事。——帕特里克 麦珍尼斯[外交部]一个外交官是这样的一个人，他总能记起女人的生日，但永远记不住她的年龄。——罗伯特 福斯特[归正教会]我不想确定上天堂还是下地狱，你看，我两边都有朋友。——马克 吐温[归正教会]现代文明的三大要素：火枪、印刷术、新教。——托马斯 卡莱尔[重商主义]在市场经济里，个人有一定可能性逃脱政府权力的控制。——彼得 贝格[重商主义]见过一个非市场经济后，我马上就明白我喜欢市场经济的哪些地方了。——伊瑟 戴森[启蒙运动]新观点总是被怀疑，经常被反对，不是因为别的，只是因为还没有变得稀松平常。——约翰 卢克[启蒙运动]反自然的就是反理性的，而所有反理性的都是荒谬的。——斯宾诺莎[殖民主义]记住，政治、殖民主义、帝国主义和战争也都是产生自人脑。——维莱亚努尔 拉马钱德兰 [殖民主义]殖民主义，是强制地传播理性的统治。可问题是谁去在殖民者中传播理性呢？——安东尼 伯吉斯[土木工程]改良的道路是笔直；但那些弯弯曲曲的小路才是守护神的道路。——威廉 布雷克[土木工程]人们在设计一个傻子也能用的东西时，总是会错误地低估了傻子的智力。——道格拉斯 亚当斯[民族主义]是民族主义者造就了国家，而不是相反。——恩斯特 格尔纳[民族主义]就像在部落主义或民族主义中体现的那样，人性为人类进化的机械提供着动力。——亚瑟 凯斯[歌剧与芭蕾]歌剧就是，当一个人被刺穿了之后，没有流血，而是唱了起来。——罗伯特 本奇立[歌剧与芭蕾]芭蕾映射着一种脆弱的力量，和一种不灵活的精准。——艾茵 兰德[自然历史]就像我在创世中展现的，我留了一些对改变世界秩序有用的暗示。——纳尔逊 埃格林[自然历史]在自然历史的造物中，我们一直发现着动物适应自然的细节：它们的食物，它们的习惯，以及它们的生活地点。——阿尔弗莱德 华莱士{进化论的同期发现者}[都市化]是工业革命和城市集中化导致了千篇一律感觉的产生。——文顿 瑟夫[都市化]城市给我的感觉是什么都是特大号的，美好和丑陋都是。——约瑟夫 布罗茨基[焦土政策]战争是地狱。——威廉 特库姆塞 舍曼[焦土政策]我只懂两样东西：保持友谊或一片焦土。——罗杰 艾尔斯[环境保护]空气和水是生命必需的两个条件，现在它们变成了国际的垃圾桶。——雅克 伊夫 库斯托[环境保护]砍伐热带雨林谋求经济增长，听上去就像把一幅文艺复兴时期的画点着了来烧菜。——爱德华 威尔逊[大众传媒]传媒的效果不是揭露真相，而是让人维持一种上瘾的状态。——克里斯朵夫 拉斯[大众传媒]不看报纸，你将知识匮乏；看了报纸，你将被人误导。——马克 吐温[动员]准备战争的时候，那些当权者演讲时说的最多的就是“和平”，直到他们完成了总动员。——斯蒂芬 茨威格[动员]为了集合民众，政府需要一个敌人。如果他们没有真正的敌人，那么他们会发明出来一个来动员我们。——释一行[资本主义]资本主义的核心问题是人们不平等地分享幸福；社会主义的核心美德是人们平等地分享悲惨。——温斯顿 丘吉尔[资本主义]一定要顺着擦钱，如果你反着擦钱的话，有些钱可能会被你擦断。——达蒙 鲁尼恩[意识形态]经验证，没有一个体系，即使那些最残忍的体系，可以脱离意识形态生存。——乔 斯洛沃[意识形态]慢慢的，意识变成意识形态，变成政策，变成实践。——南丹 尼洛卡[核计划]原子能的释放把一切都改变了，除了我门的思考方式。解决这个问题的答案在人类心中。如果早知道会这样，我就去当表匠了。——阿尔伯特 爱因斯坦[核计划]核时代的孩子们可能会降低爱的能力，当你抱住自己的迎接冲击波的时候很难爱上别人。——马丁 艾米斯[选举权]为什么女性要被区别对待？女性选举权会成功的，即使有游击队恐怖的反对。——维多利亚 伍德哈尔[选举权]男人，有他们的权利，一样不能多；女人，有她们的权利，一样不能少。——苏珊 安东尼[极权主义]只有暴徒和精英才会被极权主义所吸引，其他普罗大众的支持要靠宣传赢取。——汉娜 阿伦特[极权主义]任何意识形态的极端都是极权主义。——汤姆 罗宾逊[阶级斗争]阶级战争是存在的，不过是我这个阶级-富人阶级-在制造战争，而且，我们赢了。——沃伦 巴菲特[阶级斗争]阶级斗争的最终结果是无产阶级专政。——卡尔 马克思 [文化遗产]一个民族如果对自己的过去、起源和文化没有了解的话就像一棵树没有了根。——马科斯 加维 [文化遗产]不是你无意中发现了文化遗迹，它一直就在那里，等着被人探索、发现。——罗比 罗伯逊 [冷战]从波罗的海的什切青到亚德里亚海的的里亚斯特，一条铁幕在欧洲大陆上降下了。——温斯顿 丘吉尔[冷战]冷战没有解冻，而是在高温下剧烈地烧着。——理查德 尼克松[职业体育]如果输赢无所谓，那他们干嘛还记分呢？——文思 伦巴第[职业体育]体育没有塑造性格，而是揭示了性格。——海伍德 布朗恩[快速部署]一个立刻执行的不错的计划，要好过下周执行的完美计划。——乔治 S 巴顿[快速部署]别管调遣，直接冲过去！——霍雷肖 纳尔逊[太空竞赛]我们选择这个十年登月和做其他的事情，不是因为它们简单，而是因为它们难。——约翰 肯尼迪[太空竞赛]NASA花了几百万美元研究在太空用的圆珠笔。而俄罗斯人拿了个铅笔。——威尔 查博特[全球化]有人说过，反对全球化，就好像反对万有引力定律一样。——科菲 安南[全球化]总有一天，这世上没有边境，没有国界，没有旗帜，没有国家，唯一的护照就是你的心。——卡洛斯 桑塔纳[社交网络]我要先告诉你哪件我重要的琐事呢？——简 奥斯汀[社交网络]被一件分心的事从另一件分心的事上分心了。——T S',

      //中间的字符串数组strArray
      //['[职业体育]如果输赢无所谓，那他们干嘛还记分呢？——文思', '[阶级斗争]阶级斗争的最终结果是无产阶级专政。——卡尔 马克思'']
      strArray: [],


      //最终要获得的对象数组sayingsArray
      //[{name: '文思', saying:'[职业体育]如果输赢无所谓，那他们干嘛还记分呢？'}, {name:'卡尔 马克思', saying:'[阶级斗争]阶级斗争的最终结果是无产阶级专政。'}]
      sayingsArray: []
     }
    },
    methods: {
      getStrArray(string){
        this.strArray = string.split('[')
        for(var i = 1; i< this.strArray.length; i++){
          this.strArray[i] = '[' + this.strArray[i]
          this.getSayingArray(this.strArray)
        }
      },

      getSayingArray(array){
        for(var i=1; i<array.length; i++){
          var index = array[i].indexOf('——')
          var name = array[i].slice(index+2)
          var saying = array[i].slice(0,index)
          this.sayingsArray[i-1] = {name:name,saying:saying}
        }
      },

      switchSaying(){
        var num = Math.floor(Math.random()*100)
        this.say = this.sayingsArray[num]
      }
  },
  created(){
    //获得中间字符串数组
    this.getStrArray(this.str)
    //切换名言
    this.switchSaying()
  }
}
</script>

<style scoped lang="less">
  .say {
    width: 23.4375rem;
    background: #FAFBFE;
    padding: 2.5rem 0 1.875rem 0;
    text-align: center;
    // overflow: hidden;
    .sayTop{
      
      img{
        width: 2rem;
        float: left;
        margin: 0 0.75rem 0 3.0625rem;
      }
      div{
        float: left;
        width: 14.5625rem ;
        margin: 0 3rem 0.625rem 0;
        
        font-size: 0.875rem;
        line-height: 1.1875rem;
        color: #31384E;
      }
    }
    .sayMid{
      font-size: 0.875rem;
      color: #697598;
      margin: 0 0 1.875rem 0;
    }
    .sayBottom{
      font-size: 1.125rem;
      color: #207BFA;
    }
  }


  
</style>
